import { scroll } from './locomotive';
import { breakpoints } from '../utils/breakpoints';

const handleNav = () => {
  const selectors = {
    header: '.js-header',
    phone: '.js-floating-phone',
    socials: '.js-floating-socials',
    catalogStickyMenu: '.js-catalog-sticky-menu',
    contactStickyMenu: '.js-contact-sticky-menu',
  };

  const classNames = {
    scrolled: 'l-header--scrolled',
    white: 'l-header--white',
    active: 'is-active',
  };

  const CSSVars = {
    catalogFilterTop: '--product-filter-top',
  };

  const header = document.querySelector(selectors.header);
  const phone = document.querySelector(selectors.phone);
  const socials = document.querySelector(selectors.socials);
  const catalogStickyMenu = document.querySelector(selectors.catalogStickyMenu);
  const contactStickyMenu = document.querySelector(selectors.contactStickyMenu);

  if (!header) return;

  let prevScroll = 0;
  let curScroll;

  const setStickyTopPosition = ({ HTMLElement, stickyMenuPostion }) => {
    HTMLElement?.style.setProperty(CSSVars.catalogFilterTop, stickyMenuPostion);
  };

  const setCatalogStickyMenuPosition = () => {
    const shouldFuncExit = window.innerWidth >= breakpoints.tablet || (catalogStickyMenu === null && contactStickyMenu === null);

    if (shouldFuncExit) return;

    const stickyMenuPostion = curScroll + 1 < prevScroll ? `${header.clientHeight}px` : 0;

    setStickyTopPosition({ stickyMenuPostion, HTMLElement: catalogStickyMenu });
    setStickyTopPosition({ stickyMenuPostion, HTMLElement: contactStickyMenu });
  };

  scroll.on('scroll', (args) => {
    curScroll = args.scroll.y;

    if (curScroll < 100) {
      header.classList.remove(classNames.scrolled);
    } else if (curScroll + 1 < prevScroll) {
      header.classList.remove(classNames.scrolled);
    } else {
      if (curScroll <= prevScroll + 1) return;
      header.classList.add(classNames.scrolled);
    }

    // Set catalog sticky menu position
    setCatalogStickyMenuPosition();

    if (curScroll > 100) {
      header.classList.add(classNames.white);
      phone?.classList.add(classNames.active);
      socials.classList.add(classNames.active);
    } else {
      header.classList.remove(classNames.white);
      phone?.classList.remove(classNames.active);
      socials.classList.remove(classNames.active);
    }
    prevScroll = curScroll;
  });
};

export default handleNav;
